export default __webpack_public_path__ + "static/media/SR_Azazel.73c98208.png";